import { render, staticRenderFns } from "./PromoEffect.vue?vue&type=template&id=3848eaf4&scoped=true&"
import script from "./PromoEffect.vue?vue&type=script&lang=js&"
export * from "./PromoEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3848eaf4",
  null
  
)

export default component.exports